import { render, staticRenderFns } from "./WorkflowStatistic.vue?vue&type=template&id=2c30dad2&scoped=true"
import script from "./WorkflowStatistic.vue?vue&type=script&lang=js"
export * from "./WorkflowStatistic.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStatistic.vue?vue&type=style&index=0&id=2c30dad2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30dad2",
  null
  
)

export default component.exports